<script setup lang="ts">
import { RouterLink } from 'vue-router'

import AppIcon from '../components/AppIcon.vue'
import SiteHeader from '../components/SiteHeader.vue'

defineProps<{ surface: string }>()
</script>

<template>
  <div
    class="page-wrapper error-bg"
    :style="{ backgroundImage: 'url(/images/auth-bg.jpg)' }"
  >
    <SiteHeader minimal />
    <main class="section section--top">
      <div class="container container--narrow text-center">
        <div
          v-reveal
          class="stack stack--lg"
        >
          <img
            src="/images/not-found.png"
            alt=""
            style="max-width: 24rem; margin-inline: auto"
          >
          <h4 class="fw-6">
            {{ surface }}
          </h4>
          <p class="muted-text">
            This surface is not part of the game. Head back to the join page to find your Game ID.
          </p>
          <div class="row-flex row-flex--center">
            <RouterLink
              to="/join"
              class="btn--primary"
            >
              Return to join <AppIcon name="arrow-right" />
            </RouterLink>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
